import { Modal, Spinner } from "react-bootstrap";

export default function LoadingModal ({ showWhen }) {
    
  return (
    <Modal show={showWhen} size="sm" centered>
      <Modal.Body className="m-3 d-flex flex-column justify-content-center align-items-center ">
        <p className="text-center m-3 mt-2">
            Please Wait
        </p>
        <Spinner animation="border" variant="primary" />
      </Modal.Body>
    </Modal>
  );
};